import cn from 'classnames/bind';
import { classNameType } from 'utils/types';

import s from './StickyColumn.module.scss';

const cx = cn.bind(s);
function StickyColumn({ children, className }) {
  return <div className={cx('wrapper', className)}>
    {children}
  </div>;
}
StickyColumn.propTypes = {
  className: classNameType,
};

export default StickyColumn;
